import { Col, Row } from "antd";
import { ko } from "date-fns/esm/locale";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useMutation } from "react-query";
import styled from "styled-components";
import { ReactComponent as Left } from "../../../../assets/icons/CalendarLeft.svg";
import { ReactComponent as Right } from "../../../../assets/icons/CalendarRight.svg";

import { getHolidays } from "../../../../apis/ReservationConfig/apis";
import { EditRepairShopBusinessRequestBody } from "../../../../apis/ReservationConfig/apis/types";
import CalendarTimeButton from "../../../../components/atoms/CalendarTimeButton";
import { CalendarTime } from "../../../../components/atoms/CalendarTimeButton/interface";
import Modal from "../../../../components/molecures/Modals/Modal";
import useModals from "../../../../hooks/useModals";
import { Holiday } from "../../../../model/Holiday";
import { HttpError } from "../../../../network/types";
import {
  DayOffDay,
  DayOffWeek,
  TemporaryBusinessType,
} from "../../../../shared/enums";
import { getHolidayArray } from "../../../../shared/options";
import { alertError } from "../../../../shared/utils";
import { theme } from "../../../../theme";
import { StyledModalContainer } from "../../styles";
import {
  getBusinessInfos,
  getResevationTimeArray,
  getTemporaryBusinessInfos,
} from "../../utils";
import ToolTip from "../ToolTip";
import { weekOfMonth } from "../../../../components/organisms/Unbookable/utils";

interface Props {
  preRequestBody?: EditRepairShopBusinessRequestBody;
}
const PreviewModal: React.FC<Props> = (props) => {
  const { preRequestBody } = props;
  const { closeModal } = useModals();
  const [month, setMonth] = useState(moment().month());
  const [nowDate, setNowDate] = useState<Date>(moment().toDate());
  const businessInfos = preRequestBody ? getBusinessInfos(preRequestBody) : [];
  const [tooltipVisible, setTooltipVisible] = useState<boolean>(true);
  const [holidayList, setHolidayList] = useState<Holiday[]>([]);
  const [timeArray, setTimeArray] = useState<CalendarTime[]>([]);
  const getHolidayListMutation = useMutation(getHolidays, {
    onSuccess: (res) => {
      setHolidayList(res.rows);
    },
    onError: (err: HttpError) => {
      if (err.status !== 404) alertError(err.message);
      setHolidayList([]);
    },
  });

  const getExcludedDates = (date: Date) => {
    const nowDate = moment(date);
    if (preRequestBody) {
      const closedDays = preRequestBody.repairShopTemporaryBusinesses?.filter(
        (value) => value.temporaryBusinessType === TemporaryBusinessType.CLOSED
      );
      if (closedDays) {
        for (let i = 0; i < closedDays?.length; i += 1) {
          const closeDay = closedDays[i];
          const isBetweenClosedDays = closeDay.temporaryBusinessStartedAt
            ? moment(nowDate)
                .hours(0)
                .minutes(0)
                .seconds(1)
                .milliseconds(0)
                .isBetween(
                  moment(closeDay.temporaryBusinessStartedAt)
                    .hours(0)
                    .minutes(0)
                    .seconds(0)
                    .milliseconds(0),
                  moment(closeDay.temporaryBusinessEndedAt)
                    .add(1, "day")
                    .hours(0)
                    .minutes(0)
                    .seconds(0)
                    .milliseconds(0)
                )
            : false;
          if (isBetweenClosedDays) return false;
        }
      }
    }
    return true;
  };
  const getWeek = (dateFrom?: Date) => {
    // 해당 날짜 (일)

    if (!dateFrom) return undefined;
    const newDate = _.cloneDeep(dateFrom);
    const currentDate = newDate.getDate();

    // 이번 달 1일로 지정
    const startOfMonth = new Date(newDate.setDate(1));

    // 이번 달 1일이 무슨 요일인지 확인
    const weekDay = startOfMonth.getDay(); // 0: Sun ~ 6: Sat

    // ((요일 - 1) + 해당 날짜) / 7일로 나누기 = N 주차
    return parseInt(((weekDay - 1 + currentDate) / 7).toString(), 10) + 1;
  };

  const getFilteredDates = (date: Date) => {
    const day = moment(date).day();
    const holidays =
      preRequestBody?.repairShopBusiness.repairShopHolidayWorkdays;

    const isExcluded = getExcludedDates(date);
    if (isExcluded === false) return false;
    if (preRequestBody) {
      for (let i = 0; i < holidayList?.length; i += 1) {
        const holiday = holidayList[i];

        if (
          moment(date).format("YYYY-MM-DD") ===
          moment(holiday.publicHoliday)
            .locale("kr")
            .hours(0)
            .format("YYYY-MM-DD")
        ) {
          if (holidays?.includes(holiday.publicHolidayName)) return true;
          return false;
        }
      }

      const changedDays =
        preRequestBody.repairShopTemporaryBusinesses?.filter(
          (value) =>
            value.temporaryBusinessType === TemporaryBusinessType.CHANGED
        ).length > 0 &&
        preRequestBody.repairShopTemporaryBusinesses?.filter(
          (value) =>
            value.temporaryBusinessType === TemporaryBusinessType.CHANGED
        )[0];

      if (changedDays) {
        const isBetweenChangedDays = changedDays.temporaryBusinessEndedAt
          ? moment(date)
              .hours(0)
              .minutes(0)
              .seconds(1)
              .milliseconds(0)
              .isBetween(
                moment(changedDays.temporaryBusinessStartedAt)
                  .hours(0)
                  .minutes(0)
                  .seconds(0)
                  .milliseconds(0),
                moment(changedDays.temporaryBusinessEndedAt)
                  .add(1, "day")
                  .hours(0)
                  .minutes(0)
                  .seconds(0)
                  .milliseconds(0)
              )
          : true;
        if (isBetweenChangedDays) return true;
      }
      switch (day) {
        case 0:
          if (
            !preRequestBody?.repairShopBusiness.sundayStartBusinessTime ||
            !preRequestBody?.repairShopBusiness.sundayEndBusinessTime
          )
            return false;
          break;
        case 1:
          if (
            !preRequestBody?.repairShopBusiness.mondayStartBusinessTime ||
            !preRequestBody?.repairShopBusiness.mondayEndBusinessTime
          )
            return false;
          break;
        case 2:
          if (
            !preRequestBody?.repairShopBusiness.tuesdayStartBusinessTime ||
            !preRequestBody?.repairShopBusiness.tuesdayEndBusinessTime
          )
            return false;
          break;
        case 3:
          if (
            !preRequestBody?.repairShopBusiness.wednesdayStartBusinessTime ||
            !preRequestBody?.repairShopBusiness.wednesdayEndBusinessTime
          )
            return false;
          break;
        case 4:
          if (
            !preRequestBody?.repairShopBusiness.thursdayStartBusinessTime ||
            !preRequestBody?.repairShopBusiness.thursdayEndBusinessTime
          )
            return false;
          break;
        case 5:
          if (
            !preRequestBody?.repairShopBusiness.fridayStartBusinessTime ||
            !preRequestBody?.repairShopBusiness.fridayEndBusinessTime
          )
            return false;
          break;
        case 6:
          if (
            !preRequestBody?.repairShopBusiness.saturdayStartBusinessTime ||
            !preRequestBody?.repairShopBusiness.saturdayEndBusinessTime
          )
            return false;
          break;
        default:
          break;
      }
      if (preRequestBody.repairShopBusiness.repairShopDayOffs) {
        const dayOffs = preRequestBody.repairShopBusiness.repairShopDayOffs;
        const dayOffsDays = dayOffs?.map((val) => val.dayOffDay);
        switch (dayOffs[0]?.dayOffWeek) {
          case DayOffWeek.EVERY_WEEK:
            switch (date.getDay()) {
              case 0:
                return !dayOffsDays?.includes(DayOffDay.SUNDAY);
              case 1:
                return !dayOffsDays.includes(DayOffDay.MONDAY);
              case 2:
                return !dayOffsDays?.includes(DayOffDay.TUESDAY);
              case 3:
                return !dayOffsDays?.includes(DayOffDay.WEDNESDAY);
              case 4:
                return !dayOffsDays.includes(DayOffDay.THURSDAY);
              case 5:
                return !dayOffsDays?.includes(DayOffDay.FRIDAY);
              case 6:
                return !dayOffsDays?.includes(DayOffDay.SATURDAY);
              default:
                return true;
            }

          default: {
            /**
             * @author carol
             * 주차 수정
             */
            const weeksDayOffs = dayOffs?.filter(
              (val) => val.dayOffWeek === weekOfMonth(moment(date))
            );
            // const weeksDayOffs = dayOffs?.filter(
            //   (val) => val.dayOffWeek === getWeek(date)
            // );

            const weeksDayOffsDays = weeksDayOffs?.map((val) => val.dayOffDay);
            switch (date.getDay()) {
              case 0:
                return !weeksDayOffsDays?.includes(DayOffDay.SUNDAY);
              case 1:
                return !weeksDayOffsDays.includes(DayOffDay.MONDAY);
              case 2:
                return !weeksDayOffsDays?.includes(DayOffDay.TUESDAY);
              case 3:
                return !weeksDayOffsDays?.includes(DayOffDay.WEDNESDAY);
              case 4:
                return !weeksDayOffsDays.includes(DayOffDay.THURSDAY);
              case 5:
                return !weeksDayOffsDays?.includes(DayOffDay.FRIDAY);
              case 6:
                return !weeksDayOffsDays?.includes(DayOffDay.SATURDAY);
              default:
                return true;
            }
          }
        }
      }
    }
    return true;
  };
  useEffect(() => {
    getHolidayListMutation.mutate({
      publicYear: moment(nowDate).format("YYYY"),
      publicMonth: moment(nowDate).format("MM"),
    });
  }, [month]);

  useEffect(() => {
    const nowDay = moment(nowDate).day();
    if (preRequestBody) {
      const holidays = getHolidayArray()
        .filter(
          (val) =>
            !preRequestBody?.repairShopBusiness.repairShopHolidayWorkdays?.includes(
              val.value
            )
        )
        .map((val) => val.value);

      const changedDays =
        preRequestBody.repairShopTemporaryBusinesses?.filter(
          (value) =>
            value.temporaryBusinessType === TemporaryBusinessType.CHANGED
        )?.length > 0 &&
        preRequestBody.repairShopTemporaryBusinesses?.filter(
          (value) =>
            value.temporaryBusinessType === TemporaryBusinessType.CHANGED
        )[0];
      setTimeArray(getResevationTimeArray(businessInfos[nowDay]));
      for (let i = 0; i < holidayList?.length; i += 1) {
        const holiday = holidayList[i];

        if (
          holidays?.includes(holiday.publicHolidayName) &&
          moment(nowDate).format("YYYY-MM-DD") ===
            moment(holiday.publicHoliday)
              .locale("kr")
              .hours(0)
              .format("YYYY-MM-DD")
        ) {
          setTimeArray(getResevationTimeArray(businessInfos[7]));
        }
      }

      if (changedDays) {
        const isBetweenChangedDays = changedDays.temporaryBusinessEndedAt
          ? moment(nowDate)
              .hours(0)
              .minutes(0)
              .seconds(1)
              .milliseconds(0)
              .isBetween(
                moment(changedDays.temporaryBusinessStartedAt)
                  .hours(0)
                  .minutes(0)
                  .seconds(0)
                  .milliseconds(0),
                moment(changedDays.temporaryBusinessEndedAt)
                  .add(1, "day")
                  .hours(0)
                  .minutes(0)
                  .seconds(0)
                  .milliseconds(0)
              )
          : false;
        if (isBetweenChangedDays) {
          setTimeArray(
            getResevationTimeArray(
              getTemporaryBusinessInfos(preRequestBody, changedDays)[nowDay]
            )
          );
        } else {
          setTimeArray(getResevationTimeArray(businessInfos[nowDay]));
          for (let i = 0; i < holidayList?.length; i += 1) {
            const holiday = holidayList[i];

            if (
              !holidays?.includes(holiday.publicHolidayName) &&
              moment(nowDate).format("YYYY-MM-DD") ===
                moment(holiday.publicHoliday)
                  .locale("kr")
                  .hours(0)
                  .format("YYYY-MM-DD")
            ) {
              setTimeArray(getResevationTimeArray(businessInfos[7]));
            }
          }
        }
      } else {
        setTimeArray(getResevationTimeArray(businessInfos[nowDay]));
        for (let i = 0; i < holidayList?.length; i += 1) {
          const holiday = holidayList[i];
          if (
            !holidays?.includes(holiday.publicHolidayName) &&
            moment(nowDate).format("YYYY-MM-DD") ===
              moment(holiday.publicHoliday)
                .locale("kr")
                .hours(0)
                .format("YYYY-MM-DD")
          ) {
            setTimeArray(getResevationTimeArray(businessInfos[7]));
          }
        }
      }
      if (nowDate) if (getFilteredDates(nowDate) === false) setTimeArray([]);
    }
  }, [holidayList, nowDate]);

  return (
    <Modal
      width={940}
      title="미리보기"
      isOneBtn
      okText="닫기"
      onOk={closeModal}
      okButtonProps={{ ghost: true, type: "default" }}
    >
      <StyledModalContainer
        onClick={() => {
          setTooltipVisible(false);
        }}
      >
        <StyledInputContainer>
          <StyledCalendarWrapper>
            <StyledTitle>날짜 선택</StyledTitle>
            <DatePicker
              monthsShown={1}
              locale={ko}
              onChange={(date) => {
                if (date) {
                  setNowDate(date);
                  setMonth(moment(date).month());
                }
              }}
              inline
              onMonthChange={(monthDate) => {
                setMonth(moment(monthDate).month());
              }}
              filterDate={getFilteredDates}
              selected={nowDate}
              disabledKeyboardNavigation
              dayClassName={(date) => {
                const day = moment(date).day();
                const nowMonth = moment(date).month();
                if (moment(date).isBefore(moment().subtract(1, "d")))
                  return "disabled";
                if (getFilteredDates(date) === false) return "disabled";
                if (month !== nowMonth) return "not-now-month";
                if (day === 0) return "holiday";
                for (let i = 0; i < holidayList.length; i += 1) {
                  const holiday = holidayList[i];

                  if (
                    moment(date).hours(9).format("YYYY-MM-DD") ===
                    moment(holiday.publicHoliday).format("YYYY-MM-DD")
                  ) {
                    return "holiday";
                  }
                }
                return "notHoliday";
              }}
              renderCustomHeader={({ decreaseMonth, increaseMonth }) => {
                return (
                  <StyledCalendarHeader>
                    <StyledHeaderWrapper>
                      <LeftArrow
                        onClick={() => {
                          const prevMonth = moment(nowDate)
                            .subtract(1, "months")
                            .month();
                          const prevDate = moment(nowDate)
                            .subtract(1, "months")
                            .toDate();
                          setNowDate(prevDate);
                          setMonth(prevMonth);
                          setTimeArray([]);
                          decreaseMonth();
                        }}
                      />
                      <StyledHeaderText>
                        {moment(nowDate).year()}년 {month + 1}월
                      </StyledHeaderText>
                      <RightArrow
                        onClick={() => {
                          const nextMonth = moment(nowDate)
                            .add(1, "months")
                            .month();
                          const nextDate = moment(nowDate)
                            .add(1, "months")
                            .toDate();
                          setNowDate(nextDate);
                          setMonth(nextMonth);
                          setTimeArray([]);
                          increaseMonth();
                        }}
                      />
                    </StyledHeaderWrapper>
                    <ToolTip
                      visible={tooltipVisible}
                      text="설정한 날짜를 확인해보세요"
                    />
                  </StyledCalendarHeader>
                );
              }}
              disabledDayAriaLabelPrefix="disabled"
              minDate={new Date()}
              maxDate={moment(nowDate)
                .date(moment(nowDate).month(month).daysInMonth())
                .toDate()}
              renderDayContents={(value, date) => {
                const nowMonth = moment(date).month();
                const now = moment(date);
                for (let i = 0; i < holidayList.length; i += 1) {
                  const holiday = holidayList[i];

                  if (
                    moment(date).hours(9).format("YYYY-MM-DD") ===
                    moment(holiday.publicHoliday).format("YYYY-MM-DD")
                  ) {
                    return (
                      <StyledTodayWrapper>
                        <StyledBlank />
                        <StyledTodayValueWrapper>
                          {value}
                        </StyledTodayValueWrapper>
                        <StyledHolidaySpan>
                          {holiday.publicHolidayName}
                        </StyledHolidaySpan>
                      </StyledTodayWrapper>
                    );
                  }
                }
                if (month !== nowMonth)
                  return (
                    <StyledNotMonthDay
                      className="react-datepicker__day notHoliday react-datepicker__day--024 react-datepicker__day--disabled"
                      aria-disabled="true"
                    />
                  );

                if (now.format("MM:DD") === moment().format("MM:DD"))
                  return (
                    <StyledTodayWrapper>
                      <StyledBlank />
                      <StyledTodayValueWrapper>{value}</StyledTodayValueWrapper>

                      <StyledDotWrapper />
                    </StyledTodayWrapper>
                  );

                return value;
              }}
            />
          </StyledCalendarWrapper>
          <StyledTimeWrapper>
            <StyledTitle>시간 선택</StyledTitle>
            <Row
              style={{ marginTop: "24px" }}
              gutter={[4, 4]}
              justify="start"
              align="middle"
            >
              {timeArray.map((val: CalendarTime) => {
                return (
                  <Col key={val.time} flex="0 0 55px">
                    <CalendarTimeButton disabled={val.disabled}>
                      {val.time}
                    </CalendarTimeButton>
                  </Col>
                );
              })}
            </Row>
          </StyledTimeWrapper>
        </StyledInputContainer>
        <StyledText>
          {`
          고객들이 이렇게 예약할 수 있어요. 
          (현재 기입하신 내용 기준이며,이대로 변경을 원하실 경우 저장을 눌러주세요.)`}
        </StyledText>
      </StyledModalContainer>
    </Modal>
  );
};
const StyledNotMonthDay = styled.div`
  height: 45px;
  width: 45px;
  position: absolute;
`;

const StyledBlank = styled.div`
  height: 10px;
`;
const StyledTodayWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;
const StyledTodayValueWrapper = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  height: 25px;
  color: ${({ color }) => color || "inherit"};
`;
const StyledDotWrapper = styled.div`
  width: 4px;
  height: 4px;
  background: #8169f9;
`;
const StyledHeaderWrapper = styled.div`
  display: flex;
  width: 162px;
  align-items: center;
  justify-content: space-between;
`;
const LeftArrow = styled(Left)`
  cursor: pointer;
`;
const RightArrow = styled(Right)`
  cursor: pointer;
`;
const StyledInputContainer = styled.div`
  background-color: ${theme.colors.gray9};
  width: 100%;
  padding: 32px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const StyledHeaderText = styled.span`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
`;
const StyledTitle = styled.span`
  ${theme.typo.heading.b18};
`;
const StyledCalendarWrapper = styled.div`
  width: 360px;
  background-color: white;
  margin-bottom: 12px;
  padding: 24px 20px;
`;
const StyledTimeWrapper = styled.div`
  background: #ffffff;
  width: 360px;
  padding: 24px 20px;
`;
const StyledCalendarHeader = styled.div`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledHolidaySpan = styled.span`
  ${theme.typo.button.m12};
  color: inherit;
  font-size: 10px;
  margin-top: -5px;
`;
const StyledText = styled.span`
  white-space: pre;
`;

export default PreviewModal;
